import { Badge, Tooltip } from "@hightouch/htui";

import type { PreviewRoleResolution } from "src/graphql";

// Derived from the codegen type so the chip stays in sync with the backend shape.
export type RoleResolution = Pick<
  PreviewRoleResolution,
  "roleIdentifier" | "basis"
>;

// Backend emits only "mapping" | "default"; the map keeps display copy explicit
// (no string munging) and degrades gracefully if a new basis appears.
const BASIS_LABEL: Record<string, string> = {
  mapping: "group mapping",
  default: "default role",
};

type Props = {
  roleResolution?: RoleResolution | null;
};

export const RoleResolutionChip = ({ roleResolution }: Props) => {
  if (!roleResolution) {
    return null;
  }
  const basisLabel = BASIS_LABEL[roleResolution.basis] ?? roleResolution.basis;
  return (
    <Tooltip
      message={`This preview ran under the Snowflake role "${roleResolution.roleIdentifier}" (${basisLabel}). When Snowflake RBAC is on, previews run under your governed role instead of the source's service account.`}
    >
      <Badge>
        Ran as {roleResolution.roleIdentifier} · {basisLabel}
      </Badge>
    </Tooltip>
  );
};
